module.exports = __webpack_public_path__ + "static/media/back.322394a9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ui_icons/back.svg
// module id = 194
// module chunks = 0